/** Platform admin role_id — matches Roles.ADMIN in menu-points-kernel */
export const PLATFORM_ADMIN_ROLE_ID = '67c21946430ae7a3d2d9ca64'

export function isPlatformAdmin(user: { role_id?: string } | null | undefined): boolean {
  return String(user?.role_id) === PLATFORM_ADMIN_ROLE_ID
}
